<template>
  <div>
    <div class="my-profile section-group">
      <div class="row">
        <div class="col-12 pt-4">
          <div
            style="position: absolute; right: 0; z-index: 4; margin-top: -30px"
          >
             {{ $t('Social.group.haveGroup.msg') }}
          </div>
          <div class="form-group" v-for="(item, ix) in list" :key="ix">
            <div class="group-blocked" v-if="item.sgL_Status !== 'Enable'">
              <p class="txt"> {{ $t('Social.group.haveGroup.Enable') }}</p>
            </div>
            <article class="swipeable">
              <div class="inner">
                <a href="JavaScript:void(0)"  @click="go(item)">
                  <div class="group_message_count" v-if="item.sgL_newCount">
                    <span> {{ item.sgL_newCount }}+ </span>
                  </div>
                  <div
                    class="group_BgIMG"
                    :style="{ 'background-image': `url(${item.sgL_Logo})` }"
                  ></div>
                  <p class="group_Name">{{ item.sgL_GroupName }}</p>
                  <p class="group_income_mes">
                    {{ item.sgL_Content }}
                  </p>
                  <div class="tab-icon"></div>
                </a>
              </div>
              <div
                class="action-button delete"
                @click="ExitGroup(item, $event)"
              >
                <span class="text"> {{ $t('Social.group.haveGroup.Leavingroup') }}</span>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snap from "@/assets/js/snap.min.js";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.GetMyGroupList();
  },
  methods: {
    go(item) {
      let routeData = this.$router.resolve({
        name: "feedGroup_FeedGroupDetail",
        query: { sgL_GroupId: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    GetMyGroupList() {
      this.$api.social
        .GetMyGroupList({
          SkipCount: 0,
          MaxResultCount: 999,
        })
        .then((res) => {
          this.list = res.data.result.items;
          this.$bus.$emit("refreshCount", res.data.result.totalCount);
          this.$nextTick(() => {
            $(".swipeable .inner").each(function (e) {
              var snapper = new Snap({
                element: this,
                maxPosition: 100,
                minPosition: -100,
                disable: "left",
              });
            });
            /* $(".delete").on("click", function (e) {
              $(this).parent().slideToggle(100);
            }); */
          });
        });
    },
    ExitGroup(item) {
      this.$api.social
        .ExitGroup({
          id: item.id,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
            this.GetMyGroupList();
          } else {
            this.$message.error({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
  },
  mounted() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Social/group/haveGroup.vue